<style lang="less">
@import "../../../../styles/common-table-list.less";
</style>
<template>
<div>
    <div class="invite-top">
       <div class="title">
           <span style="font-size:14px;color:rgba(51,51,51,1);margin-left:20px;">邀请好友有好礼</span>
           <span style="margin:0px 10px 0px 30px;">邀请好友成为版权家付费会员，可获得相应红包，铜牌40、银牌180，金牌400，好友立享优惠。</span>
           <!-- <a>查看细则</a> -->
       </div>
       <ul class="invite-ul">
            <li class="li-one">
                <img :src="inviteCodeImg" alt='版权登记'/>
                <p>将专属二维码发送至好友</p>
            </li>
            <li class="li-two">
                <p style="color:#333;margin:15px 0px 10px 10px;">我的邀请码：{{inviteCode}}</p>
                <div class="line"></div>
                <p style="margin-left:10px;margin-bottom:20px;">
                    <img src="@/assets/center-1.png" alt='版权登记'/>
                    <span style="margin:0 20px 0 10px;">专属邀请链接</span>
                    <button class="btn-span"
                        v-clipboard:copy="inviteUrl"
                        v-clipboard:success="onCopy"
                        v-clipboard:error="onError">点击复制
                    </button>
                </p>
                <p style="margin-left:10px" v-if="inputFlag=='-1'">
                </p>
                <p style="margin-left:10px" v-else-if="inputFlag=='0'">
                    <img src="@/assets/join.png" alt='版权登记'/>
                    <span style="margin-left:10px;cursor:pointer" @click="goCodeNumber">输入被邀请码</span>
                </p>
                <p style="margin-left:10px" v-else>
                    <img src="@/assets/join.png" alt='版权登记'/>
                    <span style="margin-left:10px;">邀请我加入的邀请码：{{joinInviteCode}}</span>
                </p>
                <!-- <p style="margin-left:17px">
                    <img src="@/assets/center-2.png"  />
                    <span style="margin:0px 34px 0px 10px;">分享邀请到</span>
                    <img src="@/assets/weixin.png" style="height:11px;width:14px;cursor:pointer;" />
                    <img src="@/assets/kongjian.png" style="height:13px;width:15px;margin:0px 10px;cursor:pointer;" />
                    <img src="@/assets/weibo1.png" style="height:11px;width:14px;cursor:pointer;" />
                </p> -->
           </li>
            <li class="li-two" style="width:430px;margin-left:0px;">
                <p style="color:#333;margin:15px 0px 10px 10px;">邀请详情</p>
                <div class="line" style="width:280px"></div>
                <p style="margin-left:10px;margin-bottom:20px;">
                    <img src="@/assets/center-3.png" alt='版权登记'/>
                    <span style="margin:0px 10px;">我的好友：</span>
                    <span>{{inviteNumber}}个</span>
<!--                    <span style="margin-left:20px;">¥{{totalSum}}</span>-->
                </p>
              <p style="margin-left:10px">
                <img src="@/assets/center-4.png" alt='版权登记'/>
                <span style="margin:0 10px;">奖励红包：</span>
                <span class="notwrap" style="margin-right:10px;display:inline-block;position:relative;top:5px;">{{rewardRedEnvelope}}元</span>
                <Tooltip :content="tip" placement="top-start">
                  <img src="@/assets/center-tip.png" style="width: 14px;height: 14px;margin-top: -6px;" alt='版权登记'/>
                </Tooltip>

              </p>
<!--                <p style="margin-left:10px">
                    <img src="@/assets/center-4.png" alt='版权登记'/>
                    <span style="margin:0 10px;">预计奖励金：</span>
                    <span class="notwrap" style="margin-right:10px;display:inline-block;position:relative;top:5px;">{{frozenAmount}}元</span>
                    <Tooltip :content="tip" placement="top-start">
                        <img src="@/assets/center-tip.png" style="width: 14px;height: 14px;margin-top: -6px;" alt='版权登记'/>
                    </Tooltip>

                </p>-->
<!--                <p style="margin-left:10px">
                    <span style="margin:0 10px;padding-left: 20px;">可提现金额：</span>
                    <span class="notwrap" style="margin-right:5px;display:inline-block;width:85px;position:relative;top:5px;">{{truthMoney}}元</span>
                    <span style="text-decoration:underline;cursor:pointer" @click="goMoney">转出到钱包</span>
                    <span style="text-decoration:underline;cursor:pointer;margin-left:30px;" @click="getoutMoney">提现</span>
                </p>-->
            </li>
       </ul>
    </div>
    <div class="invite-bottom">
        <Tabs active-key="key1" @on-click="changeTabs">
            <Tab-pane label="成就详情" key="key1">
               <div>
                    <Row class="table-style-size">
                        <i-col span="8">时间</i-col>
                        <i-col span="6">金额</i-col>
                        <i-col span="10">备注</i-col>
                    </Row>
                    <div v-if="records.length>0">
                        <div style="height:528px">
                            <Row class="table-style-size table-style-body" v-for="(item,index) in records" :key="index">
                                <i-col span="8">{{item.getTime}}</i-col>
                                <i-col span="6">{{item.commission}}</i-col>
                                <i-col span="10" class="text-overflow-2" style="padding:0px 10px;">{{item.remarks}}</i-col>
                            </Row>
                        </div>
                        <div class="commont-page" style="margin-top:30px">
                            <Page :page-size="pageSize"  @on-change="changepage" :total="total" size="small" show-total show-elevator class="page-size-style"></Page><span class="page-total-span">/&nbsp;{{pages}}页</span>
                        </div>
                    </div>
                    <div class="empty-box" v-if="records.length<=0&&flag">
                        <img src="@/assets/empty.png" class="empty-img" alt='版权登记'/>
                        <p>表单暂无数据哦～</p>
                    </div>
               </div>
            </Tab-pane>
<!--            <Tab-pane label="提现明细" key="key2">
                <invite-page ref="mychildOne"></invite-page>
            </Tab-pane>-->
        </Tabs>
    </div>
    <!-- 转出 -->
    <generalframe @fatherMethod="fatherMethod" v-show="showDialog" maintitle="转出到钱包" ref="mychild">
        <div class="ts_content">
            <div class="ts_content_fr">
                <p>转出金额：</p>
                <input v-model="money" class="text-input" placeholder="请输入转出金额" type="text" />
            </div>
            <p class="red-p" v-if="showMoney">{{moneyTip}}</p>
            <p style="margin-top:35px">转出到钱包后可用于平台消费</p>
            <button class="btn-150" @click="submitMoney">确认转出</button>
        </div>
    </generalframe>
    <!-- 输入邀请码 -->
    <generalframe @fatherMethod="fatherMethodCode" v-show="showDialog01" maintitle="邀请码">
        <div class="ts_content">
            <div class="ts_content_fr">
                <p style="margin-right:0px">邀请码：</p>
                <input v-model="inviteNumberCode" class="text-input" placeholder="请输入邀请码" type="text" />
            </div>
            <p class="red-p" v-if="showInviteNumber" style="margin-left:116px">请输入正确的邀请码</p>
            <button class="btn-150" @click="submitNumber">确认</button>
        </div>
    </generalframe>
    <!-- 提现 -->
    <generalframe @fatherMethod="fatherMethodMoney" v-show="showModal" maintitle="提现到支付宝">
        <div class="ts_content">
            <div class="ts_content_fr">
                <p>提现金额：</p>
                <input v-model="outmoney" class="text-input" placeholder="请输入提现金额" type="text" />
            </div>
            <p class="red-p" v-if="outshowMoney">{{outmoneyTip}}</p>
            <div class="ts_content_fr">
                <p>支付宝账号：</p>
                <input v-model="zfb" class="text-input" type="text" placeholder="请输入支付宝账号" />
            </div>
            <p class="red-p" v-if="showZfb">请输入支付宝账号</p>
            <button class="btn-150" @click="submitoutMoney">申请提现</button>
        </div>
    </generalframe>
</div>
</template>

<script>
import Cookies from "js-cookie";
import { _getValidByPage,_drawMoney,_inputInviteCode,_getMoney } from "@/api/wallet.js";
import generalframe from '../../vip/lawcomponent/generalframe.vue';
import invitePage from './invitePage';
    export default {
         metaInfo: {
            title: '邀请有好礼|版权服务专家|版权家',
            meta: [{                 // set meta
                name: 'keyWords',
                content: '版权服务,版权百科,版权,版权家,版权存证,版权交易,版权监测,版权维权,版权登记,版权公证,版权签名,数字版权,版全家,版权侵权取证,版权法律维权服务,区块链版权登记,区块链版权确权,区块链版权存证,区块链版权'
            },{
                name: 'Description',
                content: '邀请有好礼,版权家,人人都是创作者，人人都是版权人。版权家秉持让版权实现更大价值的使命，使用创新的版权区块链和版权签名技术，为版权人提供极致的版权存证、版权交易、版权监测、版权维权服务体验。'
            }]
        },
        components:{
            generalframe,
            invitePage
        },
        name:'invite',
        data(){
            return{
                total:0,
                pages:1,
                pageNumber:1,
                pageSize:8,
                inviteCodeImg:"",
                inviteCode:"",
                inviteNumber:0,
                totalSum:0,
              rewardRedEnvelope: 0,
                truthMoney:0,
                frozenAmount:0,
                inviteUrl:"",
                records:[],
                flag:false,
                showDialog:!1,
                money:"",
                moneyTip:"请输入转出金额",
                showMoney:false,
                showDialog01:!1,
                showInviteNumber:false,
                inviteNumberCode:"",
                joinInviteCode:"",
                inputFlag:null,
                showModal:false,
                outmoney:"",
                zfb:"",
                outmoneyTip:"请输入提现金额",
                outshowMoney:false,
                showZfb:false,
                tip:"邀请好友获得奖励红包累计金额，可用于平台任意服务购买。"
            }
        },
        methods: {
            getCode() {
                let userInfo = Cookies.get("userInfo")?JSON.parse(Cookies.get("userInfo")):'';
                let registerId=userInfo && userInfo.id?userInfo.id:''
                this.getRequest('/registerInviteCode/getData/' + registerId).then(res => {
                    console.log("邀请 ：：： ",res.result)
                    if (res.code == 200) {
                        this.inviteCodeImg=res.result.qrCode;
                        this.inviteCode=res.result.inviteCode;
                        this.inviteNumber=res.result.inviteNumber?res.result.inviteNumber:0;
                        this.totalSum=res.result.totalSum?res.result.totalSum:0;
                        this.rewardRedEnvelope = res.result.rewardRedEnvelope ? res.result.rewardRedEnvelope : 0;
                        this.truthMoney=res.result.amount?res.result.amount:0;
                        this.frozenAmount = res.result.frozenAmount?res.result.frozenAmount:0 ;
                        this.inviteUrl =res.result.inviteUrl;
                        this.joinInviteCode=res.result.joinInviteCode;
                        this.inputFlag=res.result.inputFlag;
                        if(userInfo.vipFlag=='1' && res.result.inputFlag == '0'){
                            this.inputFlag="-1";
                        }
                        this.getValidByPage()
                    }
                })
            },
            //复制
            onCopy(e) {
                toast("复制成功，请在手机中查看");
            },
            onError(e) {
                toast("复制失败");
            },
            //选项卡
            changeTabs(val){
                if(val==0){
                    this.getValidByPage();
                }else if(val==1){
                    this.$refs.mychildOne.findByPage();
                }

            },
            getValidByPage(){
                let userInfo = Cookies.get("userInfo")?JSON.parse(Cookies.get("userInfo")):'';
                const data = {
                   pageNumber:this.pageNumber,
                   pageSize:this.pageSize,
                   sort:'create_date',
                   order:'desc',
                   registerId:userInfo && userInfo.id?userInfo.id:'',
                   inviteCode:this.inviteCode
                }
                _getValidByPage(data).then(res => {
                    if (res.code == 200) {
                        this.records=res.result.records;
                        this.flag=true;
                        this.total=Number(res.result.total);
                        this.pages=res.result.pages;
                    }
                })
            },
             //分页
            changepage(index){
                this.pageNumber = index;
                this.getValidByPage()
            },
            //触发转出
            goMoney(){
                this.showDialog = !0;
                this.showMoney=false;
            },
            fatherMethod() {
                this.showDialog = !1;
                this.money="";
                this.showMoney=false;
            },
            //邀请码
            goCodeNumber(){
                this.showDialog01 = !0;
                this.showInviteNumber=false;
            },
            fatherMethodCode(){
                this.showDialog01 = !1;
                this.showInviteNumber=false;
                this.inviteNumberCode="";
            },
            //提现-弹框
            fatherMethodMoney(){
                this.showModal = false;
                this.outmoney="";
                this.zfb="";
                this.outshowMoney=false;
                this.showZfb=false;
            },
            getoutMoney(){
                this.showModal = true;
                this.outshowMoney=false;
                this.showZfb=false;
            },
            //提现
            submitoutMoney(){
                if((10<=Number(this.outmoney)<=Number(this.truthMoney) && this.zfb) && !(this.outshowMoney || this.showZfb)){
                    this.outshowMoney=false;
                    this.showZfb = false;
                    let userInfo = Cookies.get("userInfo")?JSON.parse(Cookies.get("userInfo")):'';
                    const data={
                        registerId:userInfo && userInfo.id?userInfo.id:'',
                        drawWay:"alipay",
                        drawAccount: this.zfb,
                        drawAmount:this.outmoney,
                        drawOrigin:'commission'
                    }
                    _getMoney(data).then(res => {
                        if(res.code==200){
                            this.showModal = false;
                            toast("提交申请成功")
                            this.outmoney="";
                            this.zfb="";
                            this.getCode();
                            this.$refs.mychildOne.findByPage();
                        }else{
                            toast(res.message)
                        }
                    });
                }else{
                    this.outshowMoney= this.outshowMoney || !this.outmoney
                    this.showZfb = this.showZfb || ! this.zfb
                }
            },
            submitNumber(){
                if(this.inviteNumberCode){
                   this.showInviteNumber=false;
                   let userInfo = Cookies.get("userInfo")?JSON.parse(Cookies.get("userInfo")):'';
                    const data={
                        registerId:userInfo && userInfo.id?userInfo.id:'',
                        inviteCode:this.inviteNumberCode
                    }
                   _inputInviteCode(data).then(res=>{
                       if(res.code==200){
                           this.showDialog01 = !1;
                           this.getCode()
                       }else{
                           toast(res.message)
                       }
                   })
                }else{
                   this.showInviteNumber=true
                }
            },
            //转出
            submitMoney(){
                if(Number(this.money)>=10&&Number(this.money)<=Number(this.truthMoney)&& !(this.showMoney)){
                    this.showMoney=false;
                    let userInfo = Cookies.get("userInfo")?JSON.parse(Cookies.get("userInfo")):'';
                    const data={
                        registerId:userInfo && userInfo.id?userInfo.id:'',
                        amount:this.money,
                    }
                    _drawMoney(data).then(res => {
                        if(res.code==200){
                            this.showDialog = !1;
                            toast("转出到我的钱包成功")
                            this.money="";
                            this.$router.push({name:'wallet'})
                        }else{
                            toast(res.message)
                        }
                    });
                }else{
                    this.showMoney= this.showMoney || !this.money
                }
            },
        },
        created(){
            this.getCode();
        },
        watch: {
            'money':{
                handler:function(){
                    //let re = /^[0-9]*$/;
                    let re=/^\d+(\.\d{1,2})?$/;
                    if (re.test(this.money)){
                        if (Number(this.money) <= Number(this.truthMoney)) {
                            if (Number(this.money) < 10) {
                                this.moneyTip="转出金额不得低于10元"
                                this.showMoney = true;
                            } else {
                                this.moneyTip=""
                                this.showMoney = false;
                            }
                        } else {
                            this.moneyTip="当前可转出余额不足"
                            this.showMoney = true;
                        }
                    }else{
                        this.moneyTip="请输入正整数金额或最多保留两位小数"
                        this.showMoney = true;
                    }
                }
            },
            'inviteNumberCode':{
                handler:function(){
                    let re = /^[0-9]*$/;
                    if (re.test(this.inviteNumberCode)){
                       this.showInviteNumber=false
                    }else{
                        this.showInviteNumber=true
                    }
                }
            },
            'outmoney':{
                handler:function(){
                    let re = /^[0-9]*$/;
                    if (re.test(this.outmoney)){
                        if (Number(this.outmoney) <= Number(this.truthMoney)) {
                            if (Number(this.outmoney) < 10) {
                                this.outmoneyTip="提现金额不得低于10元"
                                this.outshowMoney = true;
                            } else {
                                this.outmoneyTip=""
                                this.outshowMoney = false;
                            }
                        } else {
                            this.outmoneyTip="当前可提现余额不足"
                            this.outshowMoney = true;
                        }
                    }else{
                        this.outmoneyTip="请输入正整数金额"
                        this.outshowMoney = true;
                    }
                }
            },
            'zfb':{
                handler:function(){
                    if(this.zfb){
                        this.showZfb = false
                    }else{
                        this.showZfb = true
                    }
                }
            }
        },
    }
</script>
<style scoped lang="less">
.btn-span{
    display: inline-block;
    border:0px;
    background:transparent;
    outline: none;
    color:#666;
    font-size: 14px;
    text-decoration: underline;
    cursor: pointer;
}
.invite-top{
    width:1108px;
    height:271px;
    background:rgba(255,255,255,1);
    box-shadow:0px 2px 18px 0px rgba(211,214,225,0.15);
    border-radius:8px;
    margin:25px;
    .title{
        width:1108px;
        height:58px;
        line-height: 58px;
        background:rgba(255,255,255,1);
        box-shadow:0px 2px 18px 0px rgba(211,214,225,0.15);
        border-radius:8px 8px 0px 0px;
        span,a{
            font-size:12px;
            color:rgba(102,102,102,1);
        }
        a{
            text-decoration: underline;
        }
    }
    .invite-ul{
        height: 173px;
        width:1068px;
        margin:20px auto;
        overflow: hidden;
        li{
            height:173px;
            float: left;
            font-size: 14px;
            color:#666;
            overflow: hidden;
            background:rgba(255,255,255,1);
            box-shadow:0px 2px 18px 0px rgba(211,214,225,0.15);
            border-radius:2px;
        }
        .li-one{
            width:156px;
            text-align: center;
            img{
                width:100px;
                height: 100px;
                margin:28px 0px 20px;
            }
            p{
                font-size:12px;
                color:rgba(51,51,51,1);
                line-height:17px;
            }
        }
        .li-two{
            width:255px;
            margin:0px 30px;
            .line{
                width:220px;
                height:1px;
                background:rgba(249,249,249,1);
                margin:0 auto;
                margin-bottom:20px;
            }
            p{
                line-height: 20px;
                img{
                    height: 20px;
                    width: 20px;
                    vertical-align: middle;
                }
            }
        }
    }
}
.invite-bottom{
    width:1108px;
    height:726px;
    background:rgba(255,255,255,1);
    box-shadow:0px 2px 40px 0px rgba(29,31,108,0.04);
    border-radius:8px;
    margin:0 auto;
    .invite-bottom-title{
        width:1108px;
        height:63px;
        line-height: 63px;
        background:rgba(255,255,255,1);
        box-shadow:0px 2px 40px 0px rgba(29,31,108,0.04);
        border-radius:8px 8px 0px 0px;
        text-indent: 20px;
    }
    /deep/ .ivu-tabs-bar{
        margin-bottom:0px;
        border-bottom:0px;
        margin-left: 25px;
    }
    /deep/ .ivu-tabs-nav .ivu-tabs-tab{

        padding:20px 0px;
        color:rgba(153,153,153,1);
        width: 95px!important;
    }
    /deep/ .ivu-tabs-nav .ivu-tabs-tab-active{
        color:rgba(51,51,51,1);
    }
    /deep/ .ivu-tabs-ink-bar{
        background-color: #333333;
         width: 60px!important;
    }
}
.ts_content{
    overflow: hidden;
    height: 230px;
    position: relative;
    .ts_content_fr{
        display:flex;
        justify-content: flex-start;
        align-items: center;
        margin-top: 30px;
        p{
            width:85px;
            text-align:left;
            margin-right:10px;
            margin-left: 30px;
            color:rgba(50,50,50,1);
        }
        .text-input{
            width:252px;
            height:46px;
            outline: none;
            border-radius:4px;
            border:1px solid rgba(222,226,230,1);
            text-indent: 10px;
            color:rgba(50,50,50,1);
        }
    }
    .btn-150{
        width:150px;
        height:37px;
        outline: none;
        border:0px;
        background:rgba(255,216,0,1);
        border-radius:21px;
        font-size:14px;
        font-weight:600;
        color:rgba(78,78,78,1);
        cursor: pointer;
        position: absolute;
        bottom:0px;
        left:135px;
    }
    .red-p{
        color: #f00;
        text-align: left;
        margin-left: 125px;
    }
}
    /deep/ .ivu-tooltip-inner{
        word-break: break-all;
        white-space: normal;
        min-width:400px !important;
        min-height:140px;
        background:rgba(255,255,255,1);
        box-shadow:0px 4px 40px 0px rgba(0,0,0,0.1);
        border-radius:6px;
        font-size:14px;
        font-weight:400;
        color:rgba(102,102,102,1);
        line-height:20px !important;
        padding-top: 16px;
        padding-left: 17px;
    }
    /deep/ .ivu-tooltip-arrow{
        bottom: 0px !important;
        border-width: 0px !important;
        border-top-color:#FFFFFF !important;
    }
</style>
